"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineRefs = combineRefs;
exports.getRefInstance = getRefInstance;

var _types = require("./types");
/* eslint-disable no-return-assign */


function combineRefs(targetRef) {
  for (var _len = arguments.length, refs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    refs[_key - 1] = arguments[_key];
  }

  if ((0, _types.arrayHasItems)(refs)) {
    if (targetRef) {
      refs.forEach(function (ref) {
        if ((0, _types.objHasOwnProperty)(ref, 'current')) {
          ref.current = targetRef;
        }
      });
    }
  }
}

function getRefInstance(ref) {
  if (ref && (0, _types.objHasOwnProperty)(ref, 'current') && ref.current) {
    return ref.current;
  }

  return null;
}